import { render } from "./WayfindingLayoutEditor.vue?vue&type=template&id=54d1e924&scoped=true&ts=true"
import script from "./WayfindingLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./WayfindingLayoutEditor.vue?vue&type=script&lang=ts"

import "./WayfindingLayoutEditor.vue?vue&type=style&index=0&id=54d1e924&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d1e924"]])

export default __exports__